<template>
  <div>
    <div class="hide-header"></div>
    <div class="top-hide-header"></div>
    <div class="header">
      <router-link to="/">
        <img class="logo"
             alt="kao chiao logo"
             src="../assets/logo.svg" />
      </router-link>
      <button class="menu-bar mobile"
              v-on:click="openMenu">
        <img src="../assets/menu-bar.svg" />
        <span>Menu</span>
      </button>
      <!-- NOTE: DO NOT INTENT TO REMOVE either desktop MenuModal OR model MenuModal -->
      <!-- the safari position fixed will not display if parent using overflow: hidden -->
      <!-- https://stackoverflow.com/questions/26704903/only-in-safari-positionfixed-child-cut-off-when-parent-is-positionfixed-and -->
      <MenuModal class="desktop"
                 :isMenuOpen="isMenuOpen"
                 @onClose="closeMenu" />
    </div>

    <div class="mobile">
      <MenuModal :isMenuOpen="isMenuOpen"
                 @onClose="closeMenu" />
    </div>
  </div>
</template>

<script>
import MenuModal from "@/components/MenuModal.vue";

export default {
  components: {
    MenuModal
  },
  data() {
    return {
      isMenuOpen: false
    };
  },
  watch: {
    $route() {
      this.closeMenu();
    }
  },
  methods: {
    openMenu() {
      this.isMenuOpen = true;
    },
    closeMenu() {
      this.isMenuOpen = false;
    }
  }
};
</script>

<style lang="scss" scpoed>
.hide-header {
  height: 104px;
}

.top-hide-header {
  position: fixed;
  width: 100%;
  height: 60px;
  max-width: 1200px;
  top: 0;
  background-color: white;
  z-index: 998;
}

.header {
  display: flex;
  align-items: flex-start;
  z-index: 999;
  background: transparent url("../assets/header-bg.png") center no-repeat;
  background-size: 1200px auto;
  padding: 11px 20px 25px;
  box-sizing: border-box;
  position: fixed;
  width: 100%;
  max-width: 1200px;
  top: 0;

  .logo {
    margin-right: 20px;
  }
}

@media (max-width: 1023px) {
  .header {
    justify-content: center;
    overflow: hidden;
  }

  .menu-bar {
    cursor: pointer;
    display: flex !important;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 30px;
    right: 0;
    border: none;
    font-size: 24px;
    background: transparent;

    img {
      width: 35px;
      vertical-align: text-bottom;
      margin-right: 5px;
    }
  }

  .header {
    .call {
      display: block !important;
      background: url("../assets/caller.svg") no-repeat;
      margin-top: 30px;
      text-align: center;
      font-size: 14px;
      font-weight: bold;
      padding-bottom: 15px;
      color: #1c2e53;
      background-position: calc(50% - 130px) top;
    }
  }
}

@media (max-width: 480px) {
  .header {
    background: transparent url("../assets/mobile-header-bg.svg") center
      no-repeat;
    background-size: 100% 100%;
    background-position: center 8px;
  }

  .menu-bar {
    font-size: 14px;
    img {
      width: 20px;
    }
  }
}
</style>
